import { t } from "@travily/i18n";
import { Wizard } from "@ui/components/Wizard";
import type { ReactNode } from "react";
import { DescriptionField, descriptionFieldCopy } from "@/components/ListingFields/DescriptionField";

const COLOR = "green" as const;
const LISTING_TYPE = "service" as const;

export interface ServiceDescriptionStepViewProps {
  /** Current stage, 1-indexed, for the progress bar. */
  currentStage: number;
  /** Total stages driving the progress bar. */
  totalStages: number;
  /** Back handler; omit on the first stage to hide the back affordance. */
  onBack?: () => void;
  /** Top-bar tertiary actions (e.g. "Questions?", "Finish later"). */
  topBarActions: ReactNode;
  /** Primary "Continue" handler. */
  onPrimary: () => void;
  /** Whether the primary button shows its pending state. */
  primaryPending: boolean;
  /** Current description value for the textarea. */
  description: string;
  /** Field error message; when present the textarea renders invalid. */
  error?: string;
  /** Fires on textarea change with the new value. */
  onDescriptionChange: (value: string) => void;
}

export const ServiceDescriptionStepView = ({
  currentStage,
  totalStages,
  onBack,
  topBarActions,
  onPrimary,
  primaryPending,
  description,
  error,
  onDescriptionChange,
}: ServiceDescriptionStepViewProps) => {
  const { heading, helper } = descriptionFieldCopy(LISTING_TYPE);

  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage heading={heading} helper={helper}>
        <div className="flex w-full flex-1 flex-col [&>*]:flex-1">
          <DescriptionField
            error={error}
            listingType={LISTING_TYPE}
            onChange={onDescriptionChange}
            value={description}
          />
        </div>
      </Wizard.Stage>
    </Wizard>
  );
};
